import { render, staticRenderFns } from "./TradesmanSkillList.vue?vue&type=template&id=60969db4&"
import script from "./TradesmanSkillList.vue?vue&type=script&lang=js&"
export * from "./TradesmanSkillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports